// Single source of truth for selectable "From" sender addresses.
// Used by Compose Email and Appointment emails. Each address must be a
// verified sender identity in AWS SES.
export const FROM_EMAILS = [
  "admissions@kotharedu.com",
  "info@kotharedu.com",
  "visa@kotharedu.com",
  "accounts@kotharedu.com",
];

export const DEFAULT_FROM_EMAIL = "info@kotharedu.com";
